import { CUSTOM_APP_EVENTS } from 'consts';

export function dispatchSkeletonAppEvent(value: boolean = false) {
  document.dispatchEvent(new CustomEvent(CUSTOM_APP_EVENTS.IS_SKELETON_VIEW, { detail: { value } }));
}
